import React, { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import AlertComponent from "../../../../Components/AlertComponent";
import CustomSelect from "../../../../Components/CustomSelect";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from "@mui/material";
import PostHooks from "../../../../Api/PostHooks";
import { LoadingButton } from "@mui/lab";
import FetchHook from "../../../../Api/FetchHooks";
import FormNumberInput from "../../../../Components/FormNumberInput";

const RepayLoanForm = ({ _user, onClose, onSuccess }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const LoggedInUser = useSelector((state) => state.auth.user);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [user, setUser] = useState(
    _user || location.state?.user || LoggedInUser,
  );

  const [userLoans, setUserLoans] = useState([]);
  const [selectedLoan, setSelectedLoan] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const [loading, response, request] = FetchHook();
  const [repyLoading, repayResponse, repayRequest] = PostHooks();

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const fetchData = useCallback(async () => {
    await request({
      url: `loan?entity_id='${user.id}'`,
    });
  }, [user]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (response && response.status === 200 && response.data.StatusCode === 0) {
      const activeLoans = response.data.Loan.filter(
        (loan) =>
          loan.active_status.includes("active") ||
          loan.active_status.includes("incomplete"),
      );
      setUserLoans(activeLoans);
      // setUserLoans(response.data.Loan);
    }
  }, [response]);

  const repayLoan = async (e) => {
    try {
      let formData = {
        loan_id: selectedLoan?.id,
        type: "early",
        amount: e.amount,
      };

      const loanReq = await repayRequest({
        url: "/early_repayment",
        body: formData,
      });

      if (loanReq && loanReq.status === 200 && loanReq.data.StatusCode === 0) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Loan repayment successful!",
        });

        setTimeout(() => {
          onClose();
          onSuccess();
        }, 1000);
      } else {
        const errorMessage =
          loanReq?.data?.StatusMessage ??
          loanReq?.data?.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      console.log("loan repayment early_repayment err", error);

      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  const loanOptions =
    userLoans.length > 0
      ? userLoans.map((loan) => ({
          value: loan,
          key: loan.id,
          label: loan.loan_name,
          secondaryLabel: `KSH ${loan.balance_payable}`,
        }))
      : [];

  return (
    <form onSubmit={handleSubmit(repayLoan)} style={{ width: "auto" }}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <CustomSelect
        label="Loan product"
        labelId="product"
        id="product"
        value={selectedLoan}
        onChange={(e) => setSelectedLoan(e.target.value)}
        options={loanOptions}
        required
        defaultValue=""
        formControlProps={{
          sx: {
            mt: "5px",
          },
        }}
      />

      <Box sx={{ mt: 2 }}>
        <FormNumberInput
          name="amount"
          control={control}
          label={`Amount`}
          rules={{
            required: "Please enter an amount!",
          }}
        />
      </Box>
      {/* 
      <FormControl
        fullWidth
        sx={{
          mt: "20px",
        }}
        error={!!errors.upto_saving_percentage}
      >
        <InputLabel htmlFor="amount">Amount</InputLabel>
        <OutlinedInput
          fullWidth
          id="amount"
          type="number"
          label="Amount"
          {...register("amount")}
          onWheel={(event) => {
            event.target.blur();
          }}
          inputProps={{ step: "any" }}
        />
        {errors.amount && <FormHelperText>Enter loan amount!</FormHelperText>}
      </FormControl> */}

      <Box
        sx={{
          gap: 2,
          pt: "40px",
          display: "flex",
          direction: "row",
          justifyContent: "flex-end",
        }}
      >
        <Button variant="outlined" type="reset" onClick={() => onClose()}>
          Cancel
        </Button>
        <LoadingButton variant="contained" type="submit" loading={repyLoading}>
          Submit
        </LoadingButton>
      </Box>
    </form>
  );
};

export default RepayLoanForm;
